/** Shared layout tokens for Basecamp admin pages (Knowledge Base, etc.) */

export const pageWrap = {
  padding: '28px 32px',
  boxSizing: 'border-box',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
}

export const pageTitle = {
  margin: '0 0 8px',
  fontSize: '20px',
  fontWeight: 700,
  color: '#111827',
}

export const pageSubtitle = {
  margin: '0 0 6px',
  color: '#64748b',
  fontSize: '14px',
  lineHeight: 1.55,
  maxWidth: 800,
}

export const pageHint = {
  margin: 0,
  color: '#94a3b8',
  fontSize: '13px',
  lineHeight: 1.5,
  maxWidth: 800,
}

export const toolbarCard = {
  marginBottom: 20,
  padding: '20px 20px 16px',
  borderRadius: 12,
  border: '1px solid #e2e8f0',
  background: '#f8fafc',
  maxWidth: 1200,
}

export const filterGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: 16,
  alignItems: 'end',
}

export const filterLabel = {
  display: 'block',
  fontSize: '12px',
  fontWeight: 600,
  color: '#475569',
  marginBottom: 6,
}

export const selectControl = {
  display: 'block',
  width: '100%',
  height: 40,
  padding: '0 12px',
  borderRadius: 8,
  border: '1px solid #cbd5e1',
  fontSize: '14px',
  color: '#0f172a',
  background: '#fff',
  boxSizing: 'border-box',
  maxWidth: '100%',
}

export const actionsRow = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
  alignItems: 'center',
  paddingTop: 16,
  marginTop: 16,
  borderTop: '1px solid #e2e8f0',
}

export const btnBase = {
  height: 40,
  padding: '0 16px',
  borderRadius: 8,
  fontSize: '13px',
  fontWeight: 600,
  cursor: 'pointer',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
}

export const btnSecondary = {
  ...btnBase,
  border: '1px solid #cbd5e1',
  background: '#fff',
  color: '#334155',
}

export const btnPrimary = {
  ...btnBase,
  border: 'none',
  background: '#2563eb',
  color: '#fff',
}

export const btnDanger = {
  ...btnBase,
  border: '1px solid #fca5a5',
  background: '#fff',
  color: '#b91c1c',
}

export const tablePanel = {
  border: '1px solid #e2e8f0',
  borderRadius: 12,
  background: '#fff',
  overflow: 'hidden',
}

export const tabStrip = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0,
  borderBottom: '1px solid #e2e8f0',
  background: '#f8fafc',
  padding: '0 12px',
}

export function tabBtnStyle(active) {
  return {
    padding: '12px 16px',
    border: 'none',
    borderBottom: active ? '2px solid #2563eb' : '2px solid transparent',
    marginBottom: -1,
    background: 'transparent',
    color: active ? '#1d4ed8' : '#64748b',
    fontSize: '13px',
    fontWeight: active ? 700 : 600,
    cursor: 'pointer',
  }
}

export const tableHeaderBar = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  padding: '10px 16px',
  borderBottom: '1px solid #f1f5f9',
  background: '#fafbfc',
}

export const tableNameChip = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  fontSize: '12px',
  fontWeight: 600,
  color: '#475569',
  background: '#f1f5f9',
  border: '1px solid #e2e8f0',
  borderRadius: 6,
  padding: '4px 10px',
}

export const th = {
  textAlign: 'left',
  padding: '10px 12px',
  fontSize: '11px',
  fontWeight: 700,
  color: '#64748b',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  borderBottom: '1px solid #e2e8f0',
  whiteSpace: 'nowrap',
  background: '#f8fafc',
}

export const td = {
  padding: '10px 12px',
  fontSize: '13px',
  color: '#0f172a',
  borderBottom: '1px solid #f1f5f9',
  verticalAlign: 'top',
}

export const tableFooter = {
  padding: '10px 16px',
  fontSize: '12px',
  color: '#64748b',
  borderTop: '1px solid #f1f5f9',
  background: '#fafbfc',
}

export const infoBanner = {
  marginBottom: 16,
  padding: '10px 14px',
  borderRadius: 8,
  background: '#eff6ff',
  border: '1px solid #bfdbfe',
  fontSize: '13px',
  color: '#1e40af',
  lineHeight: 1.5,
  maxWidth: 1200,
}

export const emptyState = {
  padding: '32px 24px',
  textAlign: 'center',
  color: '#64748b',
  fontSize: '14px',
  lineHeight: 1.55,
}

export const categoryRow = {
  marginBottom: 16,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  alignItems: 'center',
}

export function categoryPillStyle(active) {
  return {
    padding: '6px 14px',
    borderRadius: 999,
    border: active ? '1px solid #2563eb' : '1px solid #e2e8f0',
    background: active ? '#eff6ff' : '#fff',
    color: active ? '#1d4ed8' : '#475569',
    fontSize: '13px',
    fontWeight: active ? 600 : 500,
    cursor: 'pointer',
  }
}

export const linkBadgeLinked = {
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: 10,
  fontSize: '11px',
  fontWeight: 700,
  background: '#dcfce7',
  color: '#15803d',
}

export const linkBadgeUnlinked = {
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: 10,
  fontSize: '11px',
  fontWeight: 700,
  background: '#f1f5f9',
  color: '#64748b',
}
